const isObject = (input: unknown): input is object => {
  return !!input && typeof input === "object";
};

export default isObject;
